<!-- Global loader -->
<app-loader *ngIf="loaderService.isLoading$ | async"></app-loader>
<!-- <app-loader *ngIf="(loaderService.isLoading$ | async)"></app-loader> -->
<app-recharge-wallet-popup [visible]="showRechargePopup" (close)="showRechargePopup"></app-recharge-wallet-popup>

<!-- Main layout container -->
<ng-container *ngIf="showLayout">
  <!-- Show navbar if role === 0 or 4 0r 3 -->
  <app-navbar *ngIf="role === 0 || role === 4||role===3"></app-navbar>
  <div [ngClass]="{
        'main-content': role === 0 || role === 4 ||role===3,
        'non-admin-content': role !== 0
      }">
    <app-custom-toast></app-custom-toast>
    <router-outlet></router-outlet>
  </div>
</ng-container>

<!-- fallback route -->
<router-outlet *ngIf="!showLayout"></router-outlet>